import styled from 'styled-components';
import { colors, sizes, breakpoints } from '../../theme';
import { RedSquareProps } from './RedSquare.types';

const getSizeValue = (size?: 'small' | 'medium' | 'large'): string => {
  switch (size) {
    case 'small':
      return '22px';
    case 'large':
      return '40px';
    case 'medium':
    default:
      return '24px';
  }
};

export const StyledRedSquare = styled.div<RedSquareProps>`
  width: ${props => props.customSize || getSizeValue(props.size)};
  height: ${props => props.customSize || getSizeValue(props.size)};
  background: ${colors.primary};
  flex-shrink: 0;
  border-radius: ${sizes.borderRadius.small};

  ${breakpoints.media.mobile} {
    width: ${props => {
      if (props.customSize) return props.customSize;
      const size = getSizeValue(props.size);
      const numericValue = parseInt(size);
      return `${Math.max(numericValue - 2, 20)}px`;
    }};
    height: ${props => {
      if (props.customSize) return props.customSize;
      const size = getSizeValue(props.size);
      const numericValue = parseInt(size);
      return `${Math.max(numericValue - 2, 20)}px`;
    }};
  }
`;
